import React, { useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { InputOtp } from 'primereact/inputotp';
import { PasswordResetType } from '../../../../../../api/types/auth/reset-password-type';
import phoneNumberUtils from '../../../../../../utils/international-to-israeli';

interface OtpDialogProps {
  visible: boolean;
  userEmail: string;
  userPhoneNumber: string;
  resetType: PasswordResetType;
  onVerify: (otp: string) => void;
  onCancel: () => void;
}

export const OtpDialog: React.FC<OtpDialogProps> = ({
  visible,
  userEmail,
  userPhoneNumber,
  resetType,
  onVerify,
  onCancel,
}) => {
  const [otp, setOtp] = useState<string>('');
  const [error, setError] = useState<string>('');

  const isPhoneReset = resetType === PasswordResetType.PhoneNumber;

  const handleVerify = () => {
    if (!otp || otp.length !== 6) {
      setError('נא להזין קוד בן 6 ספרות');
      return;
    }
    setError('');
    onVerify(otp);
  };

  const handleCancel = () => {
    setOtp('');
    setError('');
    onCancel();
  };

  const footer = (
    <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
      <Button
        label="ביטול"
        icon="pi pi-times"
        onClick={handleCancel}
        className="p-button-text"
        style={{
          color: '#6c757d',
          padding: '8px 16px',
          borderRadius: '6px',
        }}
      />
      <Button
        label="אימות"
        icon="pi pi-check"
        onClick={handleVerify}
        severity="success"
        style={{
          padding: '8px 16px',
          borderRadius: '6px',
        }}
      />
    </div>
  );

  return (
    <Dialog
      header="אימות קוד"
      visible={visible}
      onHide={handleCancel}
      style={{ width: '500px' }}
      footer={footer}
      modal
      draggable={false}
      resizable={false}
    >
      <div style={{ padding: '24px', textAlign: 'center' }}>
        <div
          style={{
            marginBottom: '24px',
            padding: '16px',
            backgroundColor: '#e3f2fd',
            borderRadius: '8px',
            border: '1px solid #90caf9',
          }}
        >
          <i
            className={isPhoneReset ? 'pi pi-mobile' : 'pi pi-envelope'}
            style={{
              fontSize: '2rem',
              color: '#1976d2',
              marginBottom: '12px',
              display: 'block',
            }}
          />
          <p
            style={{
              margin: '0',
              fontSize: '1rem',
              color: '#212529',
              fontWeight: '500',
            }}
          >
            {isPhoneReset
              ? 'קוד אימות נשלח לטלפון הנייד:'
              : 'קוד אימות נשלח לכתובת האימייל:'}
          </p>
          <p
            style={{
              margin: '8px 0 0 0',
              fontSize: '1.1rem',
              color: '#1976d2',
              fontWeight: '600',
              direction: 'ltr',
            }}
          >
            {isPhoneReset
              ? phoneNumberUtils.internationalToIsraeli(userPhoneNumber)
              : userEmail}
          </p>
        </div>

        <div style={{ marginBottom: '16px' }}>
          <label
            style={{
              display: 'block',
              marginBottom: '12px',
              color: '#495057',
              fontWeight: '500',
              fontSize: '1rem',
            }}
          >
            הזן את קוד האימות בן 6 הספרות
          </label>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              direction: 'ltr',
            }}
          >
            <InputOtp
              value={otp}
              onChange={(e) => {
                setOtp(e.value || '');
                setError('');
              }}
              length={6}
              integerOnly
              style={{
                gap: '12px',
              }}
            />
          </div>
        </div>

        {error && (
          <div
            style={{
              marginTop: '12px',
              padding: '12px',
              backgroundColor: '#fee',
              borderRadius: '6px',
              border: '1px solid #dc3545',
            }}
          >
            <i
              className="pi pi-exclamation-circle"
              style={{ color: '#dc3545', marginLeft: '8px' }}
            />
            <span style={{ color: '#dc3545', fontSize: '0.9rem' }}>
              {error}
            </span>
          </div>
        )}

        <div
          style={{
            marginTop: '20px',
            padding: '12px',
            backgroundColor: '#f8f9fa',
            borderRadius: '6px',
          }}
        >
          <p style={{ margin: '0', fontSize: '0.875rem', color: '#6c757d' }}>
            <i className="pi pi-info-circle" style={{ marginLeft: '6px' }} />
            לא קיבלת את הקוד? בדוק את תיבת הספאם או נסה שוב
          </p>
        </div>
      </div>
    </Dialog>
  );
};
